(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("angular"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "angular", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["base"] = factory(require("jquery"), require("angular"), require("lodash"));
	else
		root["base"] = factory(root["jquery"], root["angular"], root["lodash"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : main.js
	               *  Description: Base library for creating Launchpad components/widgets/modules
	               *  ----------------------------------------------------------------
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	  'use strict';

	  var config = __webpack_require__(2); /// Launchpad configuration
	  var global = window;
	  var NS = config.NS;
	  // Create the global launchpad object is doesn't exists
	  global[NS] = global[NS] || {};
	  /*----------------------------------------------------------------*/
	  /* Launchpad NameSpace
	                                                                       /*----------------------------------------------------------------*/
	  exports.NS = NS;
	  /*----------------------------------------------------------------*/
	  /* 3rd parties
	                                                                       /*----------------------------------------------------------------*/
	  exports.$ = __webpack_require__(3); // @todo export $.noConflict();
	  __webpack_require__(4); // angular from window, it doesn't export
	  exports.ng = window.angular; // export angular

	  /*----------------------------------------------------------------*/
	  /* Modules
	                                                                       /*----------------------------------------------------------------*/
	  exports.utils = __webpack_require__(5); // lodash + custom utils;
	  exports.bus = __webpack_require__(10);
	  exports.Promise = __webpack_require__(11);
	  exports.fetch = __webpack_require__(12);
	  exports.log = __webpack_require__(13);
	  exports.error = __webpack_require__(14);
	  exports.queue = __webpack_require__(15);
	  exports.notification = __webpack_require__(16);

	  /*----------------------------------------------------------------*/
	  /* Extensions
	                                                                       /*----------------------------------------------------------------*/
	  exports.Widget = __webpack_require__(19);
	  exports.portal = __webpack_require__(20);

	  /*----------------------------------------------------------------*/
	  /* Public utility libraries
	                                                                       /*----------------------------------------------------------------*/
	  exports.startPortal = __webpack_require__(21);
	  exports.getWidgetsInfo = __webpack_require__(25);
	  exports.createModule = __webpack_require__(26);
	  exports.performance = __webpack_require__(27);

	  /*----------------------------------------------------------------*/
	  /* Helpers
	                                                                       /*----------------------------------------------------------------*/
	  exports.requireWidget = global.requireWidget || __webpack_require__(28);

	  /*----------------------------------------------------------------*/
	  /* Angular related functions
	                                                                       /*----------------------------------------------------------------*/
	  /**
	                                                                                                                                            * Angular Boostrap alias
	                                                                                                                                            * @param  {HTMLElement} el   DOM element
	                                                                                                                                            * @param  {Array} deps angular dependencies
	                                                                                                                                            * @todo move to the ng module
	                                                                                                                                            * @example
	                                                                                                                                            * base.bootstrap( DOMNODE, [angular, dependencies])
	                                                                                                                                            * @return {object}
	                                                                                                                                            */

	  exports.bootstrap = function (el, deps) {
	    return exports.ng.bootstrap(el, deps);
	  };
	  /**
	      * Angular DI helper
	      * @param  {string} lib    Recuired library
	      * @param  {string} moduleName Module name default is ng
	      * @example
	      * <pre>
	      *    var utils = base.inject('lpCoreUtils', require('core').name);
	      *    var fetch = base.inject('$http');
	      * </pre>
	      * @return {object}        Required library
	      * @todo move to the ng module
	      */
	  exports.inject = function (lib, moduleName) {
	    var deps = ['ng'];
	    if (!exports.utils.isEmpty(moduleName)) {
	      // get angular default module
	      deps.push(moduleName);
	    }
	    return exports.ng.injector(deps).get(lib);
	  };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Launchpad global configuration file
	               * @param  {[type]} require [description]
	               * @param  {[type]} exports [description]
	               * @param  {String} module) {                    exports.NS [description]
	               * @return {[type]}         [description]
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	  'use strict';
	  // global Namespace and modules / widgets namespace
	  exports.NS = 'launchpad';

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var _ = __webpack_require__(6).noConflict();

	    _.mixin(__webpack_require__(7));
	    _.mixin(__webpack_require__(8));
	    _.mixin(__webpack_require__(9));
	    //_.mixin(require('./ng'));

	    module.exports = _;

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : is.js
	               *  Description: Checking utilities.
	               *  ----------------------------------------------------------------
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var _ = __webpack_require__(6);
	    var NS = __webpack_require__(2).NS;
	    var global = window;
	    /**
	                          * Check and return true if mobile device/mobile SDK is detected or return false otherwise
	                          * @return {Boolean}
	                          */
	    exports.isMobileDevice = function () {
	        //return true if mobile SDK is present
	        if (global[NS].mobileSDK) {
	            return true;
	        }

	        var deviceTypes = [
	        /iPhone|iPad|iPod/i,
	        /Android/i,
	        /BlackBerry/i,
	        /Opera Mini/i,
	        /IEMobile/i,
	        /MeeGo/i];


	        for (var i = 0, l = deviceTypes.length; i < l; i++) {
	            if (navigator.userAgent.match(deviceTypes[i])) {
	                return true;
	            }
	        }

	        return false;
	    };

	    /**
	        * Check if b$ is available and is not mocked
	        * @return {Boolean}
	        * @todo remove b$.bdom check after b$.isMocked as flag is added on all b$'s mock libs
	        */
	    exports.isb$Mocked = function () {
	        var b$ = global.b$;
	        return _.isUndefined(b$) ||
	        Boolean(b$.isMocked) === true ||
	        _.isUndefined(b$.bdom);
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var _ = __webpack_require__(6);

	    /**
	                                * Replace all portal placeholders
	                                * @param  {string} string Template used
	                                * @return {string}        Resolved string
	                                * @todo
	                                *     - pass in the resolver as well so is more flexible
	                                *     - move to portal module as utility
	                                */
	    exports.resolvePortalPlaceholders = function (string) {
	        if (!_.isString(string)) {
	            return string;
	        }

	        var replaceWith = _.get(window, 'b$.portal.config.serverRoot', '');
	        var replacements = [
	        '$(contextRoot)',
	        '$(contextPath)',
	        '$(servicesPath)'];

	        var string = _.reduce(replacements, function (str, replace) {
	            return str.replace(replace, replaceWith);
	        }, string);

	        string = string.replace('[BBHOST]', '%5BBBHOST%5D');

	        return string;
	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var _ = __webpack_require__(6);

	    /**
	                                * use to warn for deprecated methods
	                                * @return console warn and calls the aliased function
	                                */
	    exports.deprecate = function (fn, tpl, data) {

	        var NODEP = window.launchpad && window.launchpad.config && window.launchpad.config.usemin;
	        if (NODEP) {
	            return fn;
	        }

	        var warned = false;

	        function warn(msg) {
	            var compiled = _.template(msg);
	            var c = window.console;
	            var warning = compiled(data);

	            if (!warned && _.isObject(c)) {
	                c.warn(warning);
	                warned = true;
	            }
	        }

	        function deprecated() {
	            warn(tpl);
	            return fn.apply(this, arguments);
	        }

	        return _.isString(fn) || !NODEP ? warn(fn) : deprecated;
	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : bus.js
	               *  Description:
	               *  ----------------------------------------------------------------
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';
	    /*----------------------------------------------------------------*/
	    /* Use b$ window.gadgets.pubsub
	                                                                         /*----------------------------------------------------------------*/
	    module.exports = window.gadgets && window.gadgets.pubsub || {
	        publish: function publish() {},
	        subscribe: function subscribe() {} };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : Promise.js
	               *  Description:
	               *  ----------------------------------------------------------------
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    __webpack_require__(4); // angular from window, it doesn't export
	    var angular = window.angular;
	    /**
	                                   * Use native Promise or angular $q Service
	                                   */
	    module.exports = window.Promise || function ($q) {
	        var P = angular.extend(function (resolver) {
	            var deferred = $q.defer();
	            resolver(deferred.resolve, deferred.reject);
	            return deferred.promise;
	        }, $q);

	        P.resolve = function (data) {
	            return $q.when(data);
	        };

	        return P;
	    }(angular.injector(['ng']).get('$q'));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}; /**
	                                                                                                                                                                                                                                                                                        *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                        *  Copyright © Backbase B.V.
	                                                                                                                                                                                                                                                                                        *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                        *  Author : Backbase R&D - Amsterdam - Launchpad
	                                                                                                                                                                                                                                                                                        *  Filename : fetch.js
	                                                                                                                                                                                                                                                                                        *  Description:
	                                                                                                                                                                                                                                                                                        *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                        */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    __webpack_require__(4); // angular from window, it doesn't export
	    var angular = window.angular;
	    var xsrf = function () {
	        var requestHeaderName = 'X-BBXSRF';
	        var cookieName = 'BBXSRF';

	        return {
	            getToken: getToken,
	            getRequestHeaderName: getRequestHeaderName };


	        function getToken() {
	            var value = '; ' + document.cookie,
	            parts = '',
	            cookie = getCookieName();

	            parts = value.split('; ' + cookie + '=');
	            if (parts.length == 2) {
	                var token = parts.pop().split(';').shift();
	                return token;
	            }
	            return undefined;
	        }

	        function getCookieName() {
	            return cookieName;
	        }

	        function getRequestHeaderName() {
	            return requestHeaderName;
	        }
	    }();


	    /**
	          * Use Angular $http Service
	          */
	    module.exports = function (http) {
	        return function (url, options) {
	            options = ((typeof url === 'undefined' ? 'undefined' : _typeof(url)) === 'object' ? url : options) || {};
	            if (options.xsrf !== false && options.method && options.method.toUpperCase() !== 'GET') {
	                options.headers = options.headers || {};
	                options.headers[xsrf.getRequestHeaderName()] = xsrf.getToken();
	            }

	            return http(angular.extend({
	                url: url,
	                method: 'get',
	                responseHeaders: {
	                    'cache-control': 'no-cache' // for old IE
	                } },
	            options));
	        };
	    }(angular.injector(['ng']).get('$http'));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : main.js
	               *  Description: Logging system
	               *  ----------------------------------------------------------------
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	  'use strict';

	  __webpack_require__(4); // angular from window, it doesn't export
	  var angular = window.angular;
	  /**
	                                 * Use Angular $log Service
	                                 */
	  module.exports = angular.injector(['ng']).get('$log');

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : handler.js
	               *  Description:
	               *  ----------------------------------------------------------------
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	  'use strict';

	  /**
	                 * @todo move lpCoreError API here;
	                 */
	  exports.captureException = function (error, options) {

	  };
	  /**
	     * Creates a custom Error Exception
	     * @param   {String} name  Exception name
	     * @returns {Object}       ErrorCustomException constructor
	     */
	  exports.createException = function (name) {
	    function ErrorException(message) {
	      this.name = name || 'Error';
	      this.message = message || 'Unknown Message';
	    }

	    ErrorException.prototype = new Error();
	    ErrorException.prototype.constructor = ErrorException;

	    return ErrorException;
	  };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Retry queue of actions.
	               *
	               * @copyright Backbase B.V.
	               * @author Backbase R&D - Amsterdam - Launchpad
	               *
	               * @name retry
	               * @memberof base
	               */
	/* eslint no-underscore-dangle:0 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var Promise = __webpack_require__(11);

	    var service = {
	        __onPushCallbacks: [] };

	    var queue = [];

	    service.queue = queue;

	    function filterByContext(contextId) {
	        var index = 0,
	        keep = [];
	        while (index < queue.length) {
	            if (queue[index].contextId === contextId) {
	                keep.push(queue.splice(index, 1)[0]);
	            } else {
	                index++;
	            }
	        }
	        return keep;
	    }

	    /**
	       *
	       * @param method {String} Name of the task to run, either "retry" or "cancel".
	       * @param [contextId] {String} contextId of the task to run.
	       * @return {Promise}
	       */
	    function dequeue(method, contextId) {

	        var allTasks = [],
	        filteredQueue = contextId ? filterByContext(contextId) : queue;

	        // Special "clear" name is used to simply drop queue tasks without either canceling or retrying.
	        // It is used in case of retring context when only the first retryObject is actually retried and the
	        // rest is cleared in case of success.
	        if (method === 'clear') {
	            filteredQueue.length = 0;
	        } else {
	            while (filteredQueue.length) {
	                allTasks.push(filteredQueue.shift()[method]());
	            }
	        }

	        return Promise.all(allTasks);
	    }

	    service.__runPushCallbacks = function (context, retryObject) {
	        service.__onPushCallbacks.forEach(function (callback) {
	            callback(context, retryObject);
	        });
	    };

	    service.push = function (context, retryFunction) {

	        return new Promise(function (resolve, reject) {

	            // Push new retry item to the stack
	            var retryObject = {
	                contextId: context.contextId,
	                retry: function retry() {
	                    return Promise.resolve(retryFunction()).then(resolve, reject);
	                },
	                cancel: reject };


	            // Push in queue and trigger onPush event
	            queue.push(retryObject);
	            service.__runPushCallbacks(context, retryObject);
	        });
	    };

	    service.hasMore = function () {
	        return queue.length > 0;
	    };

	    service.onPush = function (callback) {
	        service.__onPushCallbacks.push(callback);
	    };

	    /**
	        * Retry all same context queue callbacks one more time.
	        * @param retryObject {Object} Task object to retry.
	        */
	    service.retry = function (retryObject) {
	        return retryObject.retry().then(function () {
	            return dequeue('clear', retryObject.contextId);
	        });
	    };

	    /**
	        * Clear all tasks in queue or same context tasks.
	        * @param retryObject {Object} Task object to retry.
	        */
	    service.cancel = function (retryObject) {
	        return dequeue('cancel', retryObject.contextId);
	    };

	    module.exports = service;

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : main.js
	               *  Description:
	               *   Notifications to low-level events like errors, offline notifications, etc.
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	  'use strict';

	  // network notifications handlers
	  exports.network = __webpack_require__(17);
	  // user actions notifications
	  exports.userActivity = __webpack_require__(18);

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : network.js
	               *  Description: Network global subscription events
	               *  ----------------------------------------------------------------
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var $ = __webpack_require__(3);
	    var NS = __webpack_require__(2).NS;
	    var bus = __webpack_require__(10);
	    var utils = __webpack_require__(5);
	    var events = {
	        offline: NS + '.network.offline',
	        online: NS + '.network.online' };



	    function handleOffline(data) {
	        bus.publish('launchpad.add-notification', utils.merge({
	            notification: {
	                container: {
	                    template: 'templates/offline.html' },

	                id: 'offline-notification',
	                level: 'info',
	                message: 'Network connection has been lost.',
	                closable: true } },

	        data));
	    }

	    function handleOnline() {
	        bus.publish('launchpad.remove-notification', {
	            notification: {
	                id: 'offline-notification' } });


	    }

	    /**
	       * Initialization
	       * @return {*}
	       */
	    module.exports = function () {
	        /**
	                                  * Online & offline
	                                  * https://developer.mozilla.org/en/docs/Online_and_offline_events
	                                  */
	        $(window).
	        on('offline', handleOffline).
	        on('online', handleOnline);

	        /**
	                                     * In case of mobile platform offline event will be handed by SDK.
	                                     */
	        bus.subscribe(events.offline, handleOffline);
	        bus.subscribe(events.online, handleOnline);
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : user-activity.js
	               *  Description: User actions global subscription events
	               *  ----------------------------------------------------------------
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var $ = __webpack_require__(3);
	    var NS = __webpack_require__(2).NS;
	    var bus = __webpack_require__(10);
	    var events = {
	        userActivity: NS + '.user.activity' };


	    function notifyOnActivity() {
	        bus.publish(events.userActivity);
	    }

	    /**
	       * Initialization
	       * @return {*}
	       */
	    module.exports = function () {
	        $(document).on('click keypress', notifyOnActivity);
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : backbase-widget.js
	               *  Description: Extending BackbaseWidget Class
	               *  ----------------------------------------------------------------
	               */

	/* eslint-disable */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';
	    var utils = __webpack_require__(5);
	    var global = window;
	    var b$ = global.b$;

	    if (utils.isb$Mocked()) {return false;} // running in standalone mode

	    var NS = global.b$.bdom.getNamespace('http://backbase.com/2013/portalView');
	    var BackbaseWidget = module.exports = NS.getClass('backbaseWidget');
	    /**
	                                                                          * Overrides widget default buildDisplay to postpone actual displaying for launcher container tab style widgets
	                                                                          * @param {Boolean} forceDisplay prevents the display from postponement mechanism working. Use this, when the
	                                                                          *                               widget should actually be displayed
	                                                                          */

	    BackbaseWidget.prototype.createDisplay = function (forceDisplay) {

	        this._displayed = this._displayed || forceDisplay;

	        //boolean expr to check if we should postpone displaying (until the tab is clicked)
	        var postponeDisplay =
	        !bd.designMode && // Disable lazy loading in Portal Manager
	        !this._displayed && //not already displayed
	        this.parentNode.tagName === 'LauncherContainer' && ( //parent is a launcher
	        this.getPreference('area') === '2' || this.getPreference('area') === '3') && //its in the launcher sidebar
	        this.getPreference('widgetChrome').indexOf('chrome-tab') > -1; //it has a tab chrome

	        if (!postponeDisplay) {
	            this._displayed = true;
	            this.constructor.superClass.prototype.createDisplay.call(this);
	        }
	    };

	    BackbaseWidget.prototype.getPreferenceFromParents = function (name) {

	        var getPreference = function getPreference(name, node) {
	            var val;
	            if (node.getPreference && node.tagName !== 'application') {
	                val = node.getPreference(name);
	                if (!val && node.parentNode) {
	                    val = getPreference(name, node.parentNode);
	                }
	            }
	            return val;
	        };

	        return getPreference(name, this);
	    };


	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.exports = function () {

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : start-portal.js
	               *  Description: Start portal
	               *      - get the portal preferences and
	               *      - initialize session timeout handler
	               *  ----------------------------------------------------------------
	               *  @todo - connect Session options with portal preferences
	               *  @todo - use base modules like (utils, portal, page)
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var utils = __webpack_require__(5);
	    var fetch = __webpack_require__(12);
	    var Session = __webpack_require__(22);
	    var Widget = __webpack_require__(19);
	    var preferencesForm = __webpack_require__(24);
	    var notifications = __webpack_require__(16);
	    var $ = __webpack_require__(3);

	    // @TODO replace with a parser form utils
	    var parseXml = function parseXml(xml) {
	        var oldXmlParser = window.be && window.be.xmlToJson;
	        return oldXmlParser({ xml: xml });
	    };

	    /**
	        * Start Launchpad portal
	        * @param  {object} portalDomModel b$-DomModel
	        * @param  {object} portal         Portal configuration
	        * @return {object}                Promise object
	        */
	    module.exports = function StartPortal(portalDomModel, portal) {
	        // @TODO replace with page module
	        // @TODO get logout URL from portal preferences
	        var page = portal.portalView.getElementsByTagName('page')[0];
	        var initSession = function initSession(portalPref) {
	            var options = {
	                logoutUrl: portalPref.serverRoot + '/j_spring_security_logout?portalName=' + portal.portalName,
	                redirectUrl: portalPref.serverRoot + portalPref.defaultLandingPage,
	                sessionUrl: portalPref.sessionEndpoint,
	                pingUrl: portalPref.sessionValidateEndpoint,
	                startCountdown: portalPref.startCountdownAt,
	                pingInterval: portalPref.sessionCheckInterval,
	                notifyAfterTimeoutDuration: portalPref.notifyAfterTimeoutDuration,
	                userLoggedIn: !!portal.loggedInUserId };

	            if (JSON.parse(page.getPreference('enableTimeout') || false)) {
	                notifications.userActivity();
	                Session.getInstance(options).init();
	            }
	        };

	        /**
	            * fetch the portal preferences form the Rest API
	            * @todo use portal module
	            * @todo cache promise
	            */
	        var getPortalPreferences = function getPortalPreferences() {
	            var url = [portal.config.serverRoot, 'portals', portal.portalName + '.xml?pc=false'].join('/');
	            var transformResponse = function transformResponse(data) {
	                if (typeof data === 'string') {
	                    data = $.parseXML(data);
	                }
	                var jsonData = parseXml(data);
	                // Add it to portal.config
	                portal.config = utils.chain(jsonData.portal.properties).
	                mapValues('value').
	                mapKeys(function (v, k) {
	                    return utils.camelCase(k);
	                }).
	                assign(portal.config).
	                value();
	                return portal.config;
	            };
	            return fetch({
	                url: url,
	                responseType: 'document',
	                transformResponse: transformResponse }).
	            then(function (response) {
	                return response.data;
	            });
	        };

	        /**
	            * Extend WidgetInstance with customChromes
	            * @todo get the chrome preferences from the portal preferences
	            * instead of uiEditingOptions
	            */
	        var addCustomChromes = function addCustomChromes(portalPref) {
	            var uiConf = window.bd && window.bd.uiEditingOptions;
	            portalPref.chromes = uiConf && uiConf.widgetPreferenceSelections ?
	            uiConf.widgetPreferenceSelections.widgetChrome //global widgetChromes
	            : [];
	            utils.assign(Widget, preferencesForm(portalPref.chromes, portal));
	            return portalPref;
	        };

	        return getPortalPreferences(portal).
	        then(addCustomChromes).
	        then(initSession);
	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Session timeout handling
	               * Pings the session endpoint to determine session time remaining.
	               * If less than 'startCountdownAt', a timeout warning is initiated.
	               * If no time is left, automatic logout
	               * User click and keyboard events revalidate the session on every ping, or immediately if the warning is active
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var utils = __webpack_require__(5);
	    var log = __webpack_require__(13);
	    var fetch = __webpack_require__(12);
	    var notifications = __webpack_require__(23);
	    var NS = __webpack_require__(2).NS;
	    var bus = __webpack_require__(10);

	    var events = {
	        userActivity: NS + '.user.activity' };


	    var formHeaders = {
	        'Accept': 'application/json',
	        'Content-Type': 'application/x-www-form-urlencoded' };


	    /*----------------------------------------------------------------*/
	    /* Export Singleton session handler
	                                                                         /*----------------------------------------------------------------*/
	    module.exports = function () {

	        var instance; // Session Handler instance
	        var config; // store the configuration options
	        var defaults = {
	            pingUrl: '$(servicesPath)/services/rest/v1/authentication/session',
	            logoutUrl: '$(contextRoot)/j_spring_security_logout',
	            keepAlive: true,
	            startCountdown: 60000,
	            notifyAfterInterval: 5000,
	            pingInterval: 30000,
	            sessionExpiredKey: 'launchpad.sessionExpired',
	            maxConsecutiveFailCount: 3,
	            userLoggedIn: false };


	        var countdownInterval; // session notification countdown interval

	        /**
	         * Session handler
	         * @param {options} options Configuration
	         * @constructor
	         */
	        function SessionHandler(options) {
	            options = options || {};
	            config = utils.chain(options).
	            defaults(defaults).
	            mapValues(utils.resolvePortalPlaceholders).
	            value();

	            this.sessionStorage = options.store || window.sessionStorage;
	            this.isPollingStarted = false;
	            this.hasSession = false;
	        }

	        /**
	           * Init Session Timeout
	           * @return {object} SessionHandler instance
	           */
	        SessionHandler.prototype.init = function () {
	            //determines if a valid session previously existed during this page load
	            this.validSessionExisted = false;
	            //records if a user event has occurred
	            this.userEventsOccurred = false;
	            //keeps track of consecutive ping fails. helps to detect internet connectivity problems
	            this.consecutiveFailCount = 0;

	            notifications.afterTimeout(config);

	            // If user is logged in enable session notifications
	            if (config.userLoggedIn) {
	                this.startPolling();
	            }
	            // adding "Continue work" button handler for notification
	            // and user activity handling
	            var self = this;
	            bus.subscribe(events.userActivity, function userEventsReceived() {
	                self.userEventsOccurred = true;
	                if (countdownInterval) {
	                    self.clearSessionWarning(true);
	                }
	            });
	        };

	        /**
	            * Start session polling
	            * @param {Number} interval defines delay before polling start
	            */
	        SessionHandler.prototype.startPolling = function (interval) {
	            window.setTimeout(this.ping.bind(this), interval || config.pingInterval);
	        };

	        /**
	            * Ping function
	            * @param {Boolean} reconfirm - flag to define if we have to refresh session or
	            * just check it
	            */
	        SessionHandler.prototype.ping = function (reconfirm) {
	            if (this.isPollingStarted) {return;}
	            this.isPollingStarted = true;

	            //decide which ping function to perform
	            this.makeSessionRequest.apply(this, reconfirm || this.userEventsOccurred ?
	            [config.pingUrl, { method: 'PUT' }] :
	            [config.pingUrl + '/validate', {}]);

	        };

	        /**
	            * Fetch session data
	            * @param {Object} options - request configuration (URL, request method, etc)
	            */
	        SessionHandler.prototype.makeSessionRequest = function (url, options) {
	            fetch(url, options).
	            then(this.handleStateResponse.bind(this), this.handleNetworkError.bind(this));
	        };

	        /**
	            * Response handling function
	            * @param {Object} responce - session request result. If request status
	            * is OK, it contains freshnessFlag and remaining time.
	            * @example response = {"remainingTime":528,"TheDataIsMostRecent":true}
	            */
	        SessionHandler.prototype.handleStateResponse = function (response) {
	            this.isPollingStarted = false;
	            this.userEventsOccurred = false;
	            notifications.dataFreshness(response.data);
	            // check badges from server
	            notifications.checkBages();
	            //if the response is a success, we know a valid session has now existed
	            this.validSessionExisted = true;

	            //reset consecutive fail count and clear offline warning (if any)
	            if (this.consecutiveFailCount >= config.maxConsecutiveFailCount) {
	                notifications.clearOfflineWarning();
	            }
	            this.consecutiveFailCount = 0;

	            //continue as normal or show timeout warning
	            var remaining = response.data.remainingTime * 1000;
	            if (remaining > config.startCountdown) {
	                //session is healthy
	                this.clearSessionWarning();
	            } else {
	                //session is running out
	                this.startSessionWarning(response.data.remainingTime);
	            }
	        };

	        /**
	            * Handle Session Errors
	            * @param {Object} error  Error Exception
	            */
	        SessionHandler.prototype.logError = function (error) {
	            log.error('SessionHandler: ', error);
	        };

	        /**
	            * Fetching fail processing
	            * @param {Object} error - response object which contains status code and
	            * error description
	            */
	        SessionHandler.prototype.handleNetworkError = function (error) {
	            error = error || {};
	            this.isPollingStarted = false;

	            if (this.validSessionExisted && error.status === 401) {
	                //if we get a 401 and a session has existed, its time to logout\
	                this.sessionStorage.clear();
	                this.sessionStorage.setItem('launchpad.sessionExpired', 'true');
	                //important to stop polling before trying to log out.
	                this.clearSessionWarning(false, true);
	                this.logout();
	            } else if (error.status === 0 && error.statusText === 'timeout') {
	                //xhr timeout occurs, use consecutive timeouts to detect internet connections problems
	                this.consecutiveFailCount++;
	                if (this.consecutiveFailCount < config.maxConsecutiveFailCount) {
	                    //start counting consecutive failures, ping soon again
	                    this.clearSessionWarning(false, true);
	                    this.startPolling(1000);
	                } else {
	                    //consecutive failures, show a warning and resume normal pinging
	                    notifications.offlineWarning();
	                    this.startPolling();
	                }
	            } else if (error.status !== 401) {
	                //any other unexpected errors
	                this.logError('Unknown error Problem validating session: ' + error.statusText);
	                this.startPolling();
	            }
	        };

	        /**
	            * Logout function
	            */
	        SessionHandler.prototype.logout = function () {
	            var self = this;
	            return fetch(config.logoutUrl, {
	                method: 'POST',
	                headers: formHeaders }).

	            then(function (response) {
	                var status = parseInt(response.status, 10);
	                if (status >= 200 && status < 300 || status === 304) {
	                    // The response returns a document and could be displayed
	                    // e.g. document.documentElement.innerHTML = response.data;
	                    // but there is an issue with a link so a redirect is used
	                    // instead.
	                    window.location.href = config.redirectUrl;
	                } else {
	                    self.logError(response.message);
	                }
	            });
	        };

	        // small helper for warning start
	        function updateEstimatedTime(time, cb) {
	            //one less second remaining now (unless already 0)
	            time = time >= 1 ? time - 1 : 0;
	            //perform a ping immediately if we estimate that time has run out
	            if (time <= 1) {
	                cb();
	            }
	            return time;
	        }

	        /**
	           * Starts the session countdown warning
	           * @param {Number} estimatedSecondsLeft - countdown time
	           */
	        SessionHandler.prototype.startSessionWarning = function (estimatedSecondsLeft) {
	            //the time left is now decremented client side and it is possible it could become out of sync with the
	            //server. for this reason it is 'estimated'
	            var self = this;
	            if (!countdownInterval) {
	                //publishes a warning message every subsequent second
	                notifications.sessionWarning(estimatedSecondsLeft);
	                estimatedSecondsLeft = updateEstimatedTime(estimatedSecondsLeft, self.ping.bind(self));
	                countdownInterval = window.setInterval(function () {
	                    //inform other components of the impending doom.
	                    notifications.sessionWarning(estimatedSecondsLeft);
	                    estimatedSecondsLeft = updateEstimatedTime(estimatedSecondsLeft, self.ping.bind(self));
	                }, 1000);
	                self.startPolling();
	            }
	        };

	        /**
	            * Clears the current session warning (if any)
	            * @param {Boolean} reconfirmSession
	            * @param {Boolean} stopPinging
	            */
	        SessionHandler.prototype.clearSessionWarning = function (reconfirmSession, stopPinging) {
	            if (reconfirmSession) {
	                //the ping response will invoke this function again in the else block, clearing the timeout warning
	                this.ping(true);
	            } else {
	                if (countdownInterval) {
	                    window.clearInterval(countdownInterval);
	                    notifications.removeNotification();
	                    countdownInterval = null;
	                }
	                if (!stopPinging) {
	                    this.startPolling();
	                }

	            }
	        };

	        /*----------------------------------------------------------------*/
	        /* Expose configurable getInstance method
	                                                                             /*----------------------------------------------------------------*/
	        return {
	            getInstance: function getInstance(options) {
	                if (utils.isUndefined(instance)) {
	                    instance = new SessionHandler(options);
	                }
	                return instance;
	            } };

	    }();
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /*global define */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var bus = __webpack_require__(10);

	    exports.checkBages = function () {
	        bus.publish('lpBadgesGetItems');
	    };

	    exports.dataFreshness = function (data) {
	        var flagName = 'TheDataIsMostRecent';
	        var status = -1;
	        if (data && data.hasOwnProperty(flagName)) {
	            status = data[flagName] === 'false' || data[flagName] === false ? 1 : 0;
	        }
	        // check data freshness status and notify the system
	        bus.publish('lpDataFreshnessValidate', status);
	    };

	    //send pubsub message when we might be offline
	    exports.offlineWarning = function () {
	        bus.publish('launchpad.add-notification', {
	            notification: {
	                id: 'offline-warning',
	                level: 'WARNING',
	                message: 'Experiencing connectivity problems. Please check your internet connection',
	                closable: false } });


	    };

	    //pubsub message to clear notifications of offline problems
	    exports.clearOfflineWarning = function () {
	        bus.publish('launchpad.remove-notification', {
	            notification: {
	                id: 'offline-warning' } });


	    };

	    //pubsub message when session time is running out. most likely the notifications widget will subscribe to this
	    exports.sessionWarning = function (estimatedTime) {
	        bus.publish('launchpad.add-notification', {
	            notification: {
	                id: 'session-timeout',
	                level: 'WARNING',
	                timeLeft: estimatedTime,
	                message: 'Session is about to expire',
	                values: {
	                    secondsLeft: estimatedTime },

	                closable: false,
	                links: [{
	                    rel: '/timeout/continue',
	                    uri: window.location.hash || '#' }] } });



	    };

	    exports.removeNotification = function () {
	        bus.publish('launchpad.remove-notification', {
	            notification: {
	                id: 'session-timeout' } });


	    };

	    exports.afterTimeout = function (config) {
	        if (window.sessionStorage.getItem(config.sessionExpiredKey)) {
	            //wait til notifications are likely to have initialized. need a message queue here!
	            window.setTimeout(function () {
	                bus.publish('launchpad.add-notification', {
	                    notification: {
	                        id: 'session-expired',
	                        level: 'INFO',
	                        message: 'Your session has expired. Please login again.',
	                        closable: true } });


	            }, config.notifyAfterTimeoutDuration || 5000);
	            window.sessionStorage.removeItem(config.sessionExpiredKey);
	        }
	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : backbase-widget.js
	               *  Description: Add Launchpad custom chrome support
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';
	    var utils = __webpack_require__(5);

	    module.exports = function (chromes, portal) {
	        chromes = chromes || [];
	        var isChromesPref = function isChromesPref(pref) {
	            return pref.name === 'widgetChrome' && (!pref.inputType.options || pref.inputType.options.length === 0);
	        };

	        return {
	            handlers: {
	                'preferences-form': function preferencesForm(ev) {
	                    var widget = ev.detail.context;
	                    var prefs = portal.portalModel.filterPreferences(widget.model.preferences.array);
	                    ev.detail.customPrefsModel = utils.each(prefs, function (pref) {
	                        if (isChromesPref(pref)) {
	                            pref.inputType.name = 'select-one';
	                            pref.inputType.options = chromes;
	                        }
	                    });
	                } } };


	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - New York
	               *  Filename : get-widgets-info.js
	               *  Description : Return a global function to check the
	               *  widgets information used on the current page.
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var NS = __webpack_require__(2).NS;
	    var utils = __webpack_require__(5);
	    var Promise = __webpack_require__(11);
	    var fetch = __webpack_require__(12);
	    var global = window;
	    // @todo  use portal module, when ready
	    var portal = global.b$ && global.b$.portal;

	    function collectWidgets(rootNode, init) {

	        var widgets = [],
	        childWidgets;

	        if (init) {
	            for (var key in rootNode) {
	                childWidgets = collectWidgets(rootNode[key]);
	                widgets = widgets.concat(childWidgets);
	            }
	        } else
	        if (rootNode.childNodes && rootNode.childNodes.length || rootNode['_children'] && rootNode['_children'].length) {
	            var children = (rootNode.childNodes || []).concat(rootNode['_children'] || []);
	            children.forEach(function (child) {
	                childWidgets = collectWidgets(child);
	                widgets = widgets.concat(childWidgets);
	            });
	        } else
	        if (rootNode.tag === 'widget') {
	            widgets.push({
	                name: rootNode.extendedItemName,
	                version: 'x.x.x',
	                src: rootNode.originalItem.preferences.src.value.
	                replace('$(contextRoot)', portal.config.serverRoot).
	                replace('index.html', '') });

	        }

	        // Filter unique and sort by name
	        return utils.chain(widgets).uniq('name').sortBy('name').value();
	    }
	    /**
	       * Expose to global namespace
	       *
	       * @return {[type]} [description]
	       */
	    global[NS].getWidgetsInfo = module.exports = function getWidgetsInfo() {

	        var all = global.b$.portal.portalModel.all;
	        var widgetsList = collectWidgets(all, true);

	        // Retrieve version information
	        var promises = widgetsList.map(function (item) {
	            return fetch(item.src + 'bower.json').then(function (response) {
	                item.version = response.data.version;
	            }, function () {
	                item.version = 'Can\'t fetch bower.json';
	            });
	        });

	        Promise.all(promises).then(function () {
	            console.table(widgetsList);
	        });
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - New York
	               *  Filename : create-module.js
	               *  ----------------------------------------------------------------
	               */
	/**
	                   * Create angular module
	                   * @param  {string} name Module name
	                   * @param  {array} deps Module dependencies
	                   * @return {object}      Angular module
	                   */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    var NS = __webpack_require__(2).NS;
	    __webpack_require__(4); // angular from window, it doesn't export
	    var angular = window.angular;
	    /**
	                                   * Check if module with `name` exists.
	                                   * TODO: Make a better check using decorated version of the angular.module that would store registered modules.
	                                   * @param name {string}
	                                   * @returns {boolean}
	                                   */
	    var moduleRegistered = function moduleRegistered(name) {
	        try {
	            angular.module(name);
	        }
	        catch (e) {
	            return false;
	        }
	        return true;
	    };

	    module.exports = function (name, deps) {

	        name = [NS, name].join('.');

	        var ngModule;

	        // Inject templates module only into widgets modules.
	        if (name.indexOf('widget-') > -1) {

	            var templatesModuleName = name + '.templates';

	            if (moduleRegistered(templatesModuleName)) {

	                deps.push(templatesModuleName);

	                // Create templateCacheInjector service
	                ngModule = angular.module(name, deps);

	                // @ngInject
	                ngModule.factory('templateCacheInjector', function ($templateCache, lpCoreTemplate) {
	                    return {
	                        put: function put(key, value) {
	                            key = lpCoreTemplate.resolvePath(key);
	                            return $templateCache.put(key, value);
	                        } };

	                });
	            } else
	            {
	                ngModule = angular.module(name, deps);
	            }
	        } else
	        {
	            ngModule = angular.module(name, deps);
	        }

	        return ngModule;
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Author : Backbase R&D - Amsterdam - Launchpad
	               *  Filename : performance.js
	               *  Description: Performance module
	               *  ----------------------------------------------------------------
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var NS = __webpack_require__(2).NS;
	    var bus = __webpack_require__(10);
	    var utils = __webpack_require__(5);

	    var DEFAULT_EVENTS = {
	        start: NS + '.performance.start',
	        end: NS + '.performance.end' };


	    // ========================================
	    // Private helpers
	    // ========================================
	    /**
	     * Returns payload data for cxp.performance events
	     * according to passed params
	     * @param data {Object}
	     * @returns {Object}
	     * @private
	     */
	    function getPayload(data) {
	        var payload = {
	            operation: data.operation };


	        // Id
	        if (data.id) {
	            payload.id = data.id;
	        }

	        // Sender
	        if (data.sender) {
	            payload.operation = '[' + data.sender + '] ' + payload.operation;
	        }

	        // Tags
	        if (data.tags && data.tags.length) {
	            payload.operation = payload.operation + ' | ' + JSON.stringify(data.tags);
	        }

	        return payload;
	    }

	    // ========================================
	    // Export
	    // ========================================
	    module.exports = function performanceFactory(params) {
	        params = utils.defaults(params || {}, {
	            bus: bus,
	            events: DEFAULT_EVENTS });


	        return {
	            /**
	                  * Starts a measurement of operation with given name.
	                  * @param {String} name - Name of the measurement.
	                  * @param {Object} data - Additional data.
	                  * @param {String} data.id - Id of operation.
	                  * @param {String} data.sender - Name of message sender.
	                  * @param {Array}  data.tags - List of tags.
	                  * @public
	                  */
	            start: function start(name, data) {
	                data = data || {};
	                data.operation = name;
	                params.bus.publish(params.events.start, getPayload(data));
	            },

	            /**
	                * Stops a measurement of operation with given name.
	                * Note, that data passed to `end` method should be equal
	                * to data that was passed to `start` method.
	                * @param name {String} Name of the measurement
	                * @param {String} name - Name of the measurement.
	                * @param {Object} data - Additional data.
	                * @param {String} data.id - Id of operation.
	                * @param {String} data.sender - Name of message sender.
	                * @param {Array}  data.tags - List of tags.
	                * @public
	                */
	            end: function end(name, data) {
	                data = data || {};
	                data.operation = name;
	                params.bus.publish(params.events.end, getPayload(data));
	            } };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}; /**
	                                                                                                                                                                                                                                                                                        *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                        *  Copyright © Backbase B.V.
	                                                                                                                                                                                                                                                                                        *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                        *  Author : Backbase R&D - Amsterdam - New York
	                                                                                                                                                                                                                                                                                        *  Filename : require-widget.js
	                                                                                                                                                                                                                                                                                        *  Description:
	                                                                                                                                                                                                                                                                                        *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                        */
	(function (root, factory) {
	    'use strict';
	    if (( false ? 'undefined' : _typeof(exports)) === 'object') {
	        module.exports = factory();
	    } else {
	        root.requireWidget = factory();
	    }
	})(undefined, function () {
	    'use strict';

	    function trim(str) {
	        if (String.prototype.trim) {
	            return str.trim();
	        }
	        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	        return str.replace(rtrim, '');
	    }

	    function isFunction(func) {
	        return typeof func === 'function';
	    }
	    function isObject(obj) {
	        return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !(obj instanceof Array);
	    }
	    function isAngularObject(obj) {
	        return isObject(obj) && typeof obj['_invokeQueue'] !== 'undefined';
	    }

	    // converts module path relative to it's index.html to path relative to portal's static dir
	    function normalizePath(rootPath, staticPath, path) {
	        try {
	            path = trim(path);
	            // remove .js from the module path if path is not absolute
	            var isAbsolute = new RegExp('^((https?|file)://|/)', 'i');
	            if (!isAbsolute.test(path)) {
	                path = path.replace(/.js$/, '');
	            }
	            path = rootPath
	            // remove slashes from the end of path
	            .replace(/[^\/]*$/, '')
	            // remove static dir from absolute path
	            .replace(new RegExp('^' + staticPath), '') + path;
	        } catch (err) {
	            console.log('Error while normalizing module path.');
	            throw err;
	        }
	        return path;
	    }

	    function addClass(el, className) {
	        if (el.classList) {
	            el.classList.add(className);
	        } else {
	            el.className += ' ' + className;
	        }
	    }
	    function removeClass(el, className) {
	        if (el.classList) {
	            el.classList.remove(className);
	        } else {
	            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	        }
	    }

	    function addLoadingClass(widgetInstance) {
	        var widgetLoadingClass = 'lp-widget-loading';
	        var el = widgetInstance.body;

	        widgetInstance.loading = function (className) {
	            widgetLoadingClass = className || widgetLoadingClass;
	            addClass(el, widgetLoadingClass);
	        };
	        widgetInstance.loaded = function (doneClass) {
	            removeClass(el, widgetLoadingClass);
	            if (typeof doneClass === 'string') {
	                addClass(el, doneClass);
	            }
	        };
	    }

	    var xsrf = function () {
	        var requestHeaderName = 'X-BBXSRF';
	        var cookieName = 'BBXSRF';

	        return {
	            getToken: getToken,
	            getRequestHeaderName: getRequestHeaderName,
	            getCookieName: getCookieName,
	            getFieldName: getCookieName };


	        function getToken() {
	            var value = '; ' + document.cookie,
	            parts = '',
	            cookie = getCookieName();

	            parts = value.split('; ' + cookie + '=');
	            if (parts.length == 2) {
	                var token = parts.pop().split(';').shift();
	                return token;
	            }
	            return undefined;
	        }

	        function getCookieName() {
	            return cookieName;
	        }

	        function getRequestHeaderName() {
	            return requestHeaderName;
	        }
	    }();

	    window.launchpad = window.launchpad || {};
	    window.launchpad.xsrf = xsrf;

	    enableXsrfTokenPrefilter();

	    return function (widgetInstance, modulePath) {
	        var requirejs = window.requirejs;
	        // works only if requirejs is available
	        if (isFunction(requirejs)) {
	            var myDef = widgetInstance.myDefinition;
	            modulePath = normalizePath(
	            myDef ? myDef.sUrl : '', // root(from /) path to the widget's index.html
	            requirejs.s.contexts._.config.baseUrl, // path to the portals static dir
	            modulePath);


	            addLoadingClass(widgetInstance);

	            requirejs([encodeURI(modulePath)], function (widgetModule) {

	                // when widget module exports function
	                if (isFunction(widgetModule)) {

	                    widgetModule.call(null, widgetInstance);

	                    // when widget module exports angular module
	                } else if (isAngularObject(widgetModule)) {

	                    requirejs(['angular', 'core'], function (ng) {
	                        // @ngInject - preconfigure module core services
	                        widgetModule.config(function (lpCoreWidgetProvider, lpCoreI18nProvider, lpCoreTemplateProvider) {
	                            lpCoreWidgetProvider.useWidgetInstance(widgetInstance);
	                            lpCoreI18nProvider.useWidgetInstance(widgetInstance);
	                            lpCoreTemplateProvider.useWidgetInstance(widgetInstance);
	                        });

	                        enableXsrfTokenInterceptor(widgetModule);
	                        ng.bootstrap(widgetInstance.body || widgetInstance, [widgetModule.name]);
	                    });

	                    // when widget module exports object
	                } else if (isObject(widgetModule)) {

	                    // Call if you find an init function
	                    if (isFunction(widgetModule.run)) {
	                        if (typeof widgetInstance === 'string') {
	                            if (typeof window.jQuery !== 'undefined') {
	                                widgetInstance = window.jQuery(widgetInstance);
	                            } else {
	                                widgetInstance = window.document.querySelectorAll(widgetInstance);
	                            }
	                        }
	                        widgetModule.run.call(null, widgetInstance);
	                    }
	                }
	            });
	        }
	    };

	    /**
	        * Configure the AngularJS $http service to add XSRF token to outgoing requests
	        *
	        * @param {Module} app - An angular module
	        * @param {Function()<string>} xsrfToken - A nullary function that returns the xsrf token
	        * @param {Object} xsrfOptions - An object containing the requestHeader key
	        * @return void
	        */
	    function enableXsrfTokenInterceptor(app) {
	        app.config(['$httpProvider', function ($httpProvider) {
	            $httpProvider.interceptors.push(function () {
	                return {
	                    request: addXsrfHeader };

	            });
	        }]);

	        /**
	              * Add XSRF header to outgoing $http requests
	              *
	              * @param {object} xhrOptions - options object passed to $http call
	              * @return {object|promise<object>}
	              */
	        function addXsrfHeader(xhrOptions) {
	            if (xhrOptions.xsrf !== false && xhrOptions.method !== 'GET') {
	                xhrOptions.headers[xsrf.getRequestHeaderName()] = xsrf.getToken();
	            }
	            return xhrOptions;
	        }
	    }

	    /**
	       * Add a jQuery.ajax prefilter to automatically insert the XSRF token in outgoing requests
	       *
	       * @param {Function()<string>} xsrfToken - A nullary function that returns the xsrf token
	       * @param {Object} xsrfOptions - Configuration containing requestHeader key
	       * @return void
	       */
	    function enableXsrfTokenPrefilter() {
	        if (!window.jQuery) {return;}

	        window.jQuery.ajaxPrefilter(function (xhrOptions, original, xhr) {
	            if (xhrOptions.xsrf === false || xhrOptions.type.toUpperCase() === 'GET') {
	                return;
	            }

	            // set xsrf request header
	            xhr.setRequestHeader(xsrf.getRequestHeaderName(), xhrOptions.xsrf || xsrf.getToken());
	        });
	    }
	});

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js